// extracted by mini-css-extract-plugin
export default {"radarBox":"_4-SelectingFocusAreaStep_radarBox__-ljZz","topTextSection":"_4-SelectingFocusAreaStep_topTextSection__YYGQh"};